<script lang="ts">
import { computed } from 'vue';
import PlayArrow from '../../assets/svg/PlayArrow.vue';
import PlayArrowFocused from '../../assets/svg/PlayArrowFocused.vue';
import PlayArrowHovered from '../../assets/svg/PlayArrowHovered.vue';

type Props = {
  isHovered?: boolean;
  isFocused?: boolean;
};
</script>

<script setup lang="ts">
const { isFocused, isHovered } = defineProps<Props>();

const icon = computed(() =>
  isFocused ? PlayArrowFocused : isHovered ? PlayArrowHovered : PlayArrow,
);
</script>

<template>
  <component :is="icon" :class="[$style.icon, isFocused && $style.focused]" />
</template>

<style module lang="scss">
@forward './Play.scss';
</style>
